import {WidgetHeaderTitlePart} from '../../widget-header-title';

export const W_HEADER_TITLE_PART_TEXT_TYPE = 'TEXT';

export interface WHeaderTitlePartTextData {
    text: string;
    translate: boolean;
}

export type WHeaderTitlePartText = WidgetHeaderTitlePart<typeof W_HEADER_TITLE_PART_TEXT_TYPE,
    WHeaderTitlePartTextData>;

export const createWHeaderTitlePartText = (text: string, translate: boolean = false): WHeaderTitlePartText => ({
    type: W_HEADER_TITLE_PART_TEXT_TYPE,
    data: {
        text,
        translate
    }
});
